let basePath = "/keys"
function getPathByName(name) {
    return `${basePath}/${name}`
}

export default {
    basePath,
    getPathByName,
}